import { useTranslation } from 'react-i18next'
import React from 'react'

import { SmallText, Title } from '../../../packages/kiti/components/presentation/Text'
import { useModalData } from '../../../components/modals/ModalsContext'
import { useProject } from './_load/ProjectLoader'

const ModalHeader = props => {
  const { t } = useTranslation('projects')
  const { clone } = useModalData() || {}
  const project = useProject() || {}

  let title = t('project.create')
  if (project.id) title = t('project.edit')
  if (clone) title = t('project.cloning')

  let subtitle = false
  if (project.id) subtitle = project.name
  if (clone)
    subtitle = (
      <>
        {t('project.cloning.subtitle')} <b>{project?.name}</b>
      </>
    )

  return (
    <>
      <Title size="h4" noMargin>
        {title}
      </Title>

      {subtitle && <SmallText size="xsmall">{subtitle}</SmallText>}
    </>
  )
}

export default ModalHeader
